import styled, { keyframes } from 'styled-components'

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 158px 30px 158px;

  @media only screen and (max-width: 414px) {
    padding: 130px 25px 0 25px !important;

    .line-style {
      padding: 20% 0 50% 10px !important;
    }
  }

  @media only screen and (max-width: 630px) {
    .row-section {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .row-section {
      .ant-col-12 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }

  @media only screen and (max-width: 820px) {
    padding: 130px 74px 30px 74px;
  }

  .row-top {
    top: 10%;
    margin-left: 10px;
  }

  .bottom {
    padding-bottom: 10%;
  }

  .line-style {
    display: content;
    /* justify-content: center; */
    padding: 10% 0 18% 10px;
  }
`

export const Title = styled.h1`
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 150px;
  font-size: clamp(30px,9vw, 64px);
  text-align: left;

  @media only screen and (max-width: 414px) {
    line-height: 60px;
    margin: 0;
  }
`

const Increase = keyframes`
  100% {
        width: 95%;
    }
 `

export const Line = styled.div`
  border: 1px solid #707070;
  height: 0px;
  width: 1px;
  -webkit-animation: ${Increase} 3s;
  -moz-animation: ${Increase} 3s;
  -o-animation: ${Increase} 3s;
  animation: ${Increase} 3s;
  animation-fill-mode: forwards;
`

export const TextHead = styled.p`
  font-family: 'Noto Sans Thai Bold';
  line-height: 50px;
  font-size: clamp(24px, 2.5vw, 34px);
  margin: 0;
  text-align: left;
`

export const TextSection = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  cursor: pointer;
  margin: 0;

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`
